(function()
{
	//Import classes
	var BaseState = include('WGBH.BaseState'),
		TitlePanel = include('WGBH.TitlePanel');


	/**
	 * The logic for the title state
	 * @class WGBH.TitleState
	 */
	var TitleState = function(options)
	{
		BaseState.call(this, new TitlePanel(), options);
	};
	
	
	// Extend the base class
	var p = extend(TitleState, BaseState);

	/**
	 * When the transition is done playing and we're fully in
	 */
	p.enterDone = function()
	{	
		app.soundtrack.playVO('title');
		
		this.next=this.next.bind(this);
		this.panel.play.interactive=true;
		
		this.panel.play.buttonMode = true;
		this.panel.play.defaultCursor = 'pointer';
		this.panel.play.on(app.taptype,this.next);
		
		this.panel.buttons.on("background",this.clickbg);
	};

	p.next=function(ev) {	
		app.soundtrack.playSFX('clickey');
		var coords={x:ev.data.global.x,y:ev.data.global.y};
		app.trackclickplay(coords);
		this.panel.play.off(app.taptype,this.next);
		this.nextState();
	};
	
	p.clickbg=function(ev) {
		app.trackstrayclick(ev.x,ev.y);
	};

	
	/**
	 * When the state fully exits
	 * @method  exit
	 */
	p.exit = function()
	{
		this.panel.play.off(app.taptype,this.next);
		this.panel.removeChild(this.panel.bg);
		this.panel.removeChild(this.panel.play);
	};

	//Assign to namespace
	namespace("WGBH").TitleState = TitleState;
}());
